// src/utils/auth.js

export function getToken() {
  return localStorage.getItem('token')
}

export function getUser() {
  const user = localStorage.getItem('user')
  return user ? JSON.parse(user) : null
}

export function setAuth(token, user) {
  localStorage.setItem('token', token)
  localStorage.setItem('user', JSON.stringify(user))

  // Giriş sonrası olay yayınla (App.vue yakalayacak)
  window.dispatchEvent(new Event('login-success'))
}

export function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
}
